import React, { Fragment, useState } from "react";
import { useAccount } from "wagmi";

import SplashPanel from "../components/SplashPanel";
import Background from "../components/Background";
import Pink from "../components/Pink";
import Whiteout from "../components/Whiteout";
import MintSetup from "../components/MintSetup";
import Memoryform from "../components/Memoryform";
import BridgeMint from "../components/BridgeMint";
import Finished from "../components/Finished";
import { ConnectKitButton } from "connectkit";

import { config } from "../services/web3";
import translate from "../services/translate";

import View from "./View";

const Mint = () => {
  const [carerMint, setCarerMint] = useState(false);
  const [bridgeMint, setBridgeMint] = useState(false);
  const { address, isConnecting, isConnected, isDisconnected } = useAccount(config);
  const [minted, setMinted] = useState(false);

  return (
    <Fragment>
      <View>
        {carerMint || minted ? <Whiteout /> : null}
        {!bridgeMint ? <Background /> : ( minted ? null : <Pink />)}
        <div className="header">
          <ConnectKitButton />
        </div>
        {isDisconnected ? <SplashPanel /> : null}
        {isConnecting ? <p>{translate("connecting")}</p> : null}
        {isConnected ? (
          <Fragment>
            {minted ? <Finished bridgeMint={bridgeMint} carerMint={carerMint} /> : (
              <Fragment>
              {!carerMint && !bridgeMint ? (
                <MintSetup
                  address={address}
                  setCarerMint={setCarerMint}
                  setBridgeMint={setBridgeMint}/>
              ) : null}
              {carerMint ? <Memoryform setMinted={setMinted} address={address}/> : null}
              {bridgeMint ? <BridgeMint id={bridgeMint} setMinted={setMinted} userAddress={address}/> : null}
              </Fragment>
            )}
            </Fragment>
        ) : null}
      </View>
    </Fragment>
  );
};

export default Mint;